<template>
    <!-- 전체 콘텐츠 영역 -->
    <div class="main-contents">
        <div class="news_wrap">
          <div class="path">커뮤니티 > 공지사항</div>
          <div class="title_wrap">
            <h2>공지사항</h2>
          </div>
          <!-- list -->
          <div class="news-list">
            <ul v-if="noticeList.length > 0">
              <li v-for="(noti, index) in noticeList" :key="noti.newsCenterSeq">
                <a @click="goNoticeDetail(noti.newsCenterSeq)">
                  <span class="numb">{{(pageInfo.pageUnit * (pageInfo.pageIndex-1)) + index+1}}</span>
                  <!-- <span class="text"> <span v-if="noti.newNotice=='Y'" class="icon-new">NEW</span>{{noti.newsCenterTitle}}</span> -->
                  <span class="text"><div class="news-title">{{noti.newsCenterTitle}}</div><span v-if="noti.newNotice == 'Y'" class="new">N</span></span>
                  <span class="date">{{noti.newsCenterReg | date('yyyy. MM. dd')}}</span>
                </a>
              </li>
            </ul>
            <div v-else class="view int_prj"> 
              <div class="req none">등록된 공지사항이 없습니다.</div>
            </div>
          </div>

          
          <!-- 페이징부분 -->
		<paging-comp :pageInfo="pageInfo" @page-click="goPage"/>
        </div>
      </div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';
import { noticeMeta } from '@/utils/meta';

export default {
  metaInfo : noticeMeta,

    components: { pagingComp },
    data() {
        return {
            input : {
                pageIndex: 1,
            },
            noticeList : [],
            pageInfo: {},

        }
    },
    mounted() {
        this.getNoticeList();
    },

    methods: {
        getNoticeList() {
            this.$.httpPost('/api/main/bbs/getNoticeList', this.input)
                .then(res => {
                    this.noticeList = res.data.noticeList;
                    this.pageInfo = res.data.pageInfo;
                }).catch(this.$.httpErrorCommon);
        },

        goNoticeDetail(idx) {
            this.$router.push({name: 'BBS002M02', query:{no : idx}});
        },

        goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getNoticeList();
		},
    }
}
</script>